import { render, staticRenderFns } from "./QuotationTable.vue?vue&type=template&id=68a87776&"
import script from "./QuotationTable.vue?vue&type=script&lang=js&"
export * from "./QuotationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports